const header = document.querySelector('.header');
const navdrop = document.querySelector('.link-wrap-drop');
export const dropDownEnableDisable = function (dropStatus) {
  if (dropStatus === false) {
    header.style.height = '11.2rem';
    setTimeout(() => {
      navdrop.style.display = 'flex';
    }, 300);
  } else {
    navdrop.style.display = 'none';
    header.style.height = '2.5rem';
  }
  return !dropStatus;
};
